import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const React = require("react");
import { useState } from "react";
import { allMedia, mediaLabels } from "../../../../backendApi/CollectionApi";
import { pushCollectionAction } from "../../CollectionUtils";
const defaultSize = 4;
export const MediumFilter = (param)=>{
    let { Media, activeMedia, updateMedium } = param;
    const [expanded, setExpanded] = useState(false);
    let uncheckedRemaining = defaultSize - activeMedia.size;
    // When not expanded, always show active media, and fill up with unchecked media until defaultSize is reached
    const toRender = expanded ? allMedia : allMedia.filter((m)=>activeMedia.has(m) || uncheckedRemaining-- > 0);
    const toRenderFacets = toRender.map((m)=>Media.find((f)=>f.Id === m) ?? {
            Id: m,
            Name: m,
            Count: 0
        });
    const checkbox = MediumCheckbox({
        activeMedia,
        updateMedium
    });
    const checkboxes = toRenderFacets.map(checkbox);
    return /*#__PURE__*/ _jsxs("div", {
        className: `c-filter__group expandable expandable--${expanded ? 'open' : 'closed'}`,
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "c-filter__group-title",
                children: "Soort"
            }),
            checkboxes,
            allMedia.length > defaultSize && /*#__PURE__*/ _jsxs("button", {
                className: "c-filter__toggle",
                onClick: ()=>setExpanded((s0)=>!s0),
                children: [
                    /*#__PURE__*/ _jsx("svg", {
                        className: expanded ? ' expanded' : '',
                        width: "2.4rem",
                        height: "2.4rem",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ _jsx("use", {
                            xlinkHref: "#icon--chevron-down"
                        })
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "c-filter__toggle-label",
                        children: expanded ? "Minder" : "Meer"
                    })
                ]
            })
        ]
    });
};
const MediumCheckbox = (param)=>{
    let { activeMedia, updateMedium } = param;
    return (param)=>{
        let { Id, Name, Count } = param;
        const push = pushCollectionAction();
        const checked = activeMedia.has(Id);
        const update = ()=>{
            push(`filter-medium-${checked ? 'off' : 'on'}`, Name);
            updateMedium((checked ? activeMedia.delete(Id) : activeMedia.add(Id)).toArray());
        };
        const inputId = `medium-input-${Id}`;
        const labelId = `medium-label-${Id}`;
        return /*#__PURE__*/ _jsxs("div", {
            className: "c-filter__checkbox",
            children: [
                /*#__PURE__*/ _jsx("input", {
                    id: inputId,
                    type: "checkbox",
                    checked: activeMedia.has(Id),
                    name: Name,
                    value: Id,
                    onChange: update,
                    "aria-describedby": labelId
                }),
                /*#__PURE__*/ _jsxs("label", {
                    id: labelId,
                    className: "c-filter__checkbox-label",
                    htmlFor: inputId,
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "checkbox-label__name",
                            children: mediaLabels[Id]
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "checkbox-label__count",
                            children: Count
                        })
                    ]
                })
            ]
        }, `medium__${Id}`);
    };
};
